<template>
  <div class="macchineadd">
    <b-container fluid>
      <b-row class="headerbox">
        <b-col>
          <h5>Registra una macchina</h5>
        </b-col>
      </b-row>
      <form-wizard 
            title="" 
            subtitle=""
            nextButtonText="Salva e Prosegui"
            backButtonText="Indietro"
            finishButtonText="Salva"
            color="#493240"
            stepSize="xs"
            >
        <!-- :before-change="step1"--> <!-- TODO: riaggiungere step 1-->
        <tab-content title="Macchina" :before-change="step1">
          <b-row class="separatore_text">
            <b-col>
              <hr>
            </b-col>
            <b-col>
              <h5>MACCHINA</h5>
            </b-col>
            <b-col>
              <hr>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" md="6">
              <b-form-input class="slide-up" id="codprodotto" v-model="formData.step1.codprodotto" type="text" :state="state.codprodotto" placeholder="Matricola della macchina" /><label for="codprodotto">* Matricola</label>
              <br>
              <br>
            </b-col>
            <b-col cols="12" md="6">
              <b-form-select class="slide-up" id="idCliente" v-model="formData.step1.idCliente" :options="option.clienti" :state="state.idCliente" placeholder="Seleziona un cliente" /><label for="idCliente">* Cliente</label>
              <br>
              <br>
              <br>
            </b-col>
          </b-row>
          <b-row class="separatore_text">
            <b-col>
              <hr>
            </b-col>
            <b-col>
              <h5>INDIRIZZO</h5>
            </b-col>
            <b-col>
              <hr>
            </b-col>
          </b-row>
          <b-row>
            <b-col offset-md="7">
              <b-button variant="success" size="lg" v-on:click="openModalIndirizzo()" :disabled="!formData.step1.idCliente"><font-awesome-icon icon="search-location" /> Seleziona un indirizzo del cliente</b-button>
              <br>
              <br>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <b-form-input id="search_box" type="search" placeholder="Seleziona il tuo indirizzo" :state="state.search_address" autocomplete="off" disabled></b-form-input>
              <div id="ubicazione_map"></div>
              <br>
              <br>
            </b-col>
          </b-row>
          <b-row>
            <b-col offset-md="5">
              <b-button variant="info" size="lg" v-b-toggle.referenti ><font-awesome-icon icon="chevron-down" /> Visualizza Referenti <font-awesome-icon icon="chevron-down" /></b-button>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-collapse id="referenti" class="mt-2">
                <b-card>
                  <b-row>
                    <b-col cols="12">
                      <b-form-select class="slide-up" id="idTipoluogo" v-model="formData.step1.idTipoluogo" :options="option.tipoluogo" placeholder="Tipologia di Luogo di Installazione" disabled/><label for="idTipoluogo">Tipologia Luogo*</label>
                      <br>
                      <br>
                      <br>
                    </b-col>
                  </b-row>
                  <b-row class="separatore_text">
                    <b-col>
                      <hr>
                    </b-col>
                    <b-col>
                      <h5>REFERENTE PRINCIPALE</h5>
                    </b-col>
                    <b-col>
                      <hr>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col cols="12" md="6">
                      <b-form-input class="slide-up" id="referente" v-model="formData.step1.princ_nome" type="text" :state="state.princ_nome" placeholder="Referente" disabled/><label for="referente">Referente</label>
                      <br>
                      <br>
                    </b-col>
                    <b-col cols="12" md="6">
                      <b-form-input class="slide-up" id="email" v-model="formData.step1.princ_email" type="text" :state="state.princ_email" placeholder="Email del referente" disabled/><label for="email">Email</label>
                      <br>
                      <br>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col cols="12" md="6">
                      <b-form-input class="slide-up" id="cellulare" v-model="formData.step1.princ_cellulare" type="text" :state="state.princ_cellulare" placeholder="Cellulare del referente" disabled/><label for="cellulare">Cellulare</label>
                      <br>
                      <br>
                    </b-col>
                    <b-col cols="12" md="6">
                      <b-form-input class="slide-up" id="telefono" v-model="formData.step1.princ_telefono" type="text" :state="state.princ_telefono" placeholder="Telefono del referente" disabled/><label for="telefono">Telefono fisso</label>
                      <br>
                      <br>
                    </b-col>
                  </b-row>  
                  <b-row>
                    <b-col cols="12">
                      <b-form-input class="slide-up" id="indirizzo" v-model="formData.step1.princ_indirizzo" type="text" :state="state.princ_indirizzo" placeholder="Indirizzo del referente" disabled/><label for="indirizzo">Indirizzo</label>
                      <br>
                      <br>
                    </b-col>
                  </b-row>
                  
                  <b-row class="separatore_text">
                    <b-col>
                      <hr>
                    </b-col>
                    <b-col>
                      <h5>PRIMO REFERENTE</h5>
                    </b-col>
                    <b-col>
                      <hr>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col cols="12" md="6">
                      <b-form-input class="slide-up" id="referente" v-model="formData.step1.referente1" type="text" :state="state.referente1" placeholder="Referente" disabled/><label for="referente">Referente</label>
                      <br>
                      <br>
                    </b-col>
                    <b-col cols="12" md="6">
                      <b-form-input class="slide-up" id="email" v-model="formData.step1.email1" type="text" :state="state.email1" placeholder="Email del referente" disabled/><label for="email">Email</label>
                      <br>
                      <br>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col cols="12" md="6">
                      <b-form-input class="slide-up" id="cellulare" v-model="formData.step1.cellulare1" type="text" :state="state.cellulare1" placeholder="Cellulare del referente" disabled/><label for="cellulare">Cellulare</label>
                      <br>
                      <br>
                    </b-col>
                    <b-col cols="12" md="6">
                      <b-form-input class="slide-up" id="telefono" v-model="formData.step1.telefono1" type="text" :state="state.telefono1" placeholder="Telefono del referente" disabled/><label for="telefono">Telefono fisso</label>
                      <br>
                      <br>
                    </b-col>
                  </b-row>

                  <b-row class="separatore_text">
                    <b-col>
                      <hr>
                    </b-col>
                    <b-col>
                      <h5>SECONDO REFERENTE</h5>
                    </b-col>
                    <b-col>
                      <hr>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col cols="12" md="6">
                      <b-form-input class="slide-up" id="referente" v-model="formData.step1.referente2" type="text" :state="state.referente2" placeholder="Referente" disabled/><label for="referente">Referente</label>
                      <br>
                      <br>
                    </b-col>
                    <b-col cols="12" md="6">
                      <b-form-input class="slide-up" id="email" v-model="formData.step1.email2" type="text" :state="state.email2" placeholder="Email del referente" disabled/><label for="email">Email</label>
                      <br>
                      <br>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col cols="12" md="6">
                      <b-form-input class="slide-up" id="cellulare" v-model="formData.step1.cellulare2" type="text" :state="state.cellulare2" placeholder="Cellulare del referente" disabled/><label for="cellulare">Cellulare</label>
                      <br>
                      <br>
                    </b-col>
                    <b-col cols="12" md="6">
                      <b-form-input class="slide-up" id="telefono" v-model="formData.step1.telefono2" type="text" :state="state.telefono2" placeholder="Telefono del referente" disabled/><label for="telefono">Telefono fisso</label>
                      <br>
                      <br>
                    </b-col>
                  </b-row>
                </b-card>
              </b-collapse>
              <br>
            </b-col>
          </b-row>
          <b-row class="separatore_text">
            <b-col>
              <hr>
            </b-col>
            <b-col>
              <h5>INFO MACCHINA</h5>
            </b-col>
            <b-col>
              <hr>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-textarea class="slide-up" id="descrizione" v-model="formData.step1.descrizione" :state="state.descrizione" rows="3" max-rows="6" /><label for="descrizione">* Descrizione</label>
              <br>
              <br>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="5" cols="12">
              <VueCtkDateTimePicker v-model="formData.step1.datainstallazione" button-now-translation="Data attuale" format="DD-MM-YYYY" formatted="ll" :only-date="true" color="#493240">
                <b-form-input v-model="formData.step1.datainstallazione" class="slide-up fix_datetime_picker" id="datainstallazione" :state="state.datainstallazione" type="text" placeholder="Data di installazione della macchina"/><label for="datainstallazione">Data Installazione</label>
              </VueCtkDateTimePicker>
              <br>
              <br>
            </b-col>
            <b-col md="5" cols="12">
              <VueCtkDateTimePicker v-model="formData.step1.datacollaudo" button-now-translation="Data attuale" format="DD-MM-YYYY" formatted="ll" :only-date="true" color="#493240">
                <b-form-input v-model="formData.step1.datacollaudo" class="slide-up fix_datetime_picker" id="datacollaudo" :state="state.datacollaudo" type="text" placeholder="Data di collaudo della macchina"/><label for="datacollaudo">Data Collaudo</label>
              </VueCtkDateTimePicker>
              <br>
              <br>
            </b-col>
            <b-col md="2" cols="12">
              <b-form-checkbox id="manutenzionecliente" v-model="formData.step1.manutenzionecliente" :state="state.manutenzionecliente" :value="true" :unchecked-value="false">Manutenzione accettata dal cliente</b-form-checkbox>
              <br>
              <br>
            </b-col>
          </b-row>
          <b-row class="separatore_text">
            <b-col>
              <hr>
            </b-col>
            <b-col>
              <h5>GARANZIA</h5>
            </b-col>
            <b-col>
              <hr>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="4" cols="12">
              <VueCtkDateTimePicker v-model="formData.step1.iniziogaranzia" button-now-translation="Data attuale" format="DD-MM-YYYY" formatted="ll" :only-date="true" color="#493240">
                <b-form-input v-model="formData.step1.iniziogaranzia" class="slide-up fix_datetime_picker" id="iniziogaranzia" :state="state.iniziogaranzia" type="text" placeholder="Data di inizio garanzia della macchina"/><label for="iniziogaranzia">Data Inizio</label>
              </VueCtkDateTimePicker>
              <br>
              <br>
            </b-col>
            <b-col md="4" cols="12">
              <VueCtkDateTimePicker v-model="formData.step1.finegaranzia" button-now-translation="Data attuale" format="DD-MM-YYYY" formatted="ll" :only-date="true" color="#493240">
                <b-form-input v-model="formData.step1.finegaranzia" class="slide-up fix_datetime_picker" id="finegaranzia" :state="state.finegaranzia" type="text" placeholder="Data di fine garanzia della macchina"/><label for="finegaranzia">Data Fine</label>
              </VueCtkDateTimePicker>
              <br>
              <br>
            </b-col>
            <b-col md="4" cols="12">
              <VueCtkDateTimePicker v-model="formData.step1.estensionegaranzia" button-now-translation="Data attuale" format="DD-MM-YYYY" formatted="ll" :only-date="true" color="#493240">
                <b-form-input v-model="formData.step1.estensionegaranzia" class="slide-up fix_datetime_picker" id="estensionegaranzia" :state="state.estensionegaranzia" type="text" placeholder="Data di fine estensione della garanzia  della macchina"/><label for="estensionegaranzia">Data Fine Estensione</label>
              </VueCtkDateTimePicker>
              <br>
              <br>
            </b-col>
          </b-row>
          <b-row class="separatore_text">
            <b-col>
              <hr>
            </b-col>
            <b-col>
              <h5>ALTRO</h5>
            </b-col>
            <b-col>
              <hr>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-textarea class="slide-up" id="note" v-model="formData.step1.note" :state="state.note" rows="3" max-rows="6" /><label for="note">Note</label>
              <br>
              <br>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-textarea class="slide-up" id="docprestazione" v-model="formData.step1.docprestazione" :state="state.docprestazione" rows="3" max-rows="6" /><label for="docprestazione">Documento di Prestazione</label>
              <br>
              <br>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" md="6">
              <b-form-input class="slide-up" id="passcentrale" v-model="formData.step1.passcentrale" type="text" :state="state.passcentrale" placeholder="Password di accesso ai parametri della centrale" /><label for="passcentrale">Password di Accesso alla Centrale</label>
              <br>
              <br>
            </b-col>
            <b-col cols="12" md="6">
              <b-form-input class="slide-up" id="freqmanutenzione" v-model="formData.step1.freqmanutenzione" type="text" :state="state.freqmanutenzione" placeholder="Fequenza manutenzione in giorni" /><label for="freqmanutenzione">Frequenza manutenzione in giorni</label>
              <br>
              <br>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-textarea class="slide-up" id="descimpianto" v-model="formData.step1.descimpianto" :state="state.descimpianto" rows="3" max-rows="6" /><label for="descimpianto">Descrizione Impianto</label>
              <br>
              <br>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <b-form-input class="slide-up" id="proprietario" v-model="formData.step1.proprietario" type="text" :state="state.proprietario" placeholder="Specifica il proprietario se diverso dal cliente" /><label for="proprietario">Proprietario se Diverso dal Cliente</label>
              <br>
              <br>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" md="6">
              <b-form-select class="slide-up" id="idTipomacchina" v-model="formData.step1.idTipomacchina" :options="option.tipomacchina" :state="state.idTipomacchina" placeholder="Seleziona una tipologia di macchina" /><label for="idTipomacchina">* Tipologia Macchina</label>
              <br>
              <br>
              <br>
            </b-col>
            <b-col cols="12" md="6">
              <b-form-select class="slide-up" id="idTipoelettrico" v-model="formData.step1.idTipoelettrico" :options="option.tipoelettrico" :state="state.idTipoelettrico" placeholder="Seleziona un'alimentazione elettrica" /><label for="idTipoelettrico">* Alimentazione Rete</label>
              <br>
              <br>
              <br>
            </b-col>
          </b-row>
        </tab-content>
        <!-- :before-change="step2"--> <!-- TODO: riaggiungere step 2-->
        <tab-content title="Manufatto" :before-change="step2">
          <b-row class="separatore_text">
            <b-col>
              <hr>
            </b-col>
            <b-col>
              <h5>MANUFATTO</h5>
            </b-col>
            <b-col>
              <hr>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" md="6">
              <b-form-select class="slide-up" id="idTipomanufatto" v-model="formData.step2.idTipomanufatto" :options="option.tipomanufatto" :state="state.idTipomanufatto" placeholder="Seleziona una tipologia di manufatto" /><label for="idTipomanufatto">* Tipologia Manufatto</label>
              <br>
              <br>
              <br>
            </b-col>
            <b-col cols="12" md="6">
              <b-form-select class="slide-up" id="idTipoutilizzo" v-model="formData.step2.idTipoutilizzo" :options="option.tipoutilizzo" :state="state.idTipoutilizzo" placeholder="Seleziona una tipologia di utilizzo" /><label for="idTipoutilizzo">* Tipologia Utilizzo</label>
              <br>
              <br>
              <br>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" md="6">
              <b-form-select class="slide-up" id="idTipouso" v-model="formData.step2.idTipouso" :options="option.tipouso" :state="state.idTipouso" placeholder="Seleziona una tipologia di uso previsto" /><label for="idTipouso">* Tipologia Uso Previsto</label>
              <br>
              <br>
              <br>
            </b-col>
            <b-col cols="12" md="6">
              <b-form-select class="slide-up" id="idTipotamponamento" v-model="formData.step2.idTipotamponamento" :options="option.tipotamponamento" :state="state.idTipotamponamento" placeholder="Seleziona una tipologia di tamponamento" /><label for="idTipotamponamento">* Tipologia Tamponamento</label>
              <br>
              <br>
              <br>
            </b-col>
          </b-row>
          <b-row class="separatore_text">
            <b-col>
              <hr>
            </b-col>
            <b-col>
              <h5>DATA</h5>
            </b-col>
            <b-col>
              <hr>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6" cols="12">
              <VueCtkDateTimePicker v-model="formData.step2.datainstallazione" button-now-translation="Data attuale" format="DD-MM-YYYY" formatted="ll" :only-date="true" color="#493240">
                <b-form-input v-model="formData.step2.datainstallazione" class="slide-up fix_datetime_picker" id="datainstallazione-2" :state="state.datainstallazione" type="text" placeholder="Data di installazione del manufatto"/><label for="datainstallazione">Installazione</label>
              </VueCtkDateTimePicker>
              <br>
              <br>
            </b-col>
            <b-col md="6" cols="12">
              <VueCtkDateTimePicker v-model="formData.step2.datapresaincarico" button-now-translation="Data attuale" format="DD-MM-YYYY" formatted="ll" :only-date="true" color="#493240">
                <b-form-input v-model="formData.step2.datapresaincarico" class="slide-up fix_datetime_picker" id="datapresaincarico" :state="state.datapresaincarico" type="text" placeholder="Data di presa in carico del manufatto"/><label for="datapresaincarico">Presa in Carico</label>
              </VueCtkDateTimePicker>
              <br>
              <br>
            </b-col>
          </b-row>
          <b-row class="separatore_text">
            <b-col>
              <hr>
            </b-col>
            <b-col>
              <h5>SPECIFICHE MANUFATTO</h5>
            </b-col>
            <b-col>
              <hr>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" md="6">
              <b-form-input class="slide-up" id="matrmanufatto" v-model="formData.step2.matrmanufatto" :state="state.matrmanufatto" type="text" placeholder="Matricola del manufatto"/><label for="matrmanufatto">Matricola del Manufatto</label>
              <br>
              <br>
            </b-col>
            <b-col cols="12" md="6">
              <b-form-input class="slide-up" id="classevetro" v-model="formData.step2.classevetro" :state="state.classevetro" type="text" placeholder="Classe resistenza vento"/><label for="classevetro">Classe Resistenza Vento</label>
              <br>
              <br>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" md="5">
              <b-form-input class="slide-up" id="dimluce" v-model="formData.step2.dimluce" :state="state.dimluce" type="number" placeholder="Dimensione luce passaggio"/><label for="dimluce">Dimensione Luce Passaggio</label>
              <br>
              <br>
            </b-col>
            <b-col cols="12" md="3">
              <b-form-input class="slide-up" id="peso" v-model="formData.step2.peso" :state="state.peso" type="number" placeholder="Peso"/><label for="peso">Peso</label>
              <br>
              <br>
            </b-col>
            <b-col cols="12" md="4">
              <b-form-input class="slide-up" id="altezza" v-model="formData.step2.altezza" :state="state.altezza" type="number" placeholder="Altezza"/><label for="altezza">Altezza</label>
              <br>
              <br>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" md="6">
              <b-form-input class="slide-up" id="numante" v-model="formData.step2.numante" :state="state.numante" type="number" placeholder="Numero ante"/><label for="numante">Numero Ante</label>
              <br>
              <br>
            </b-col>
            <b-col cols="12" md="6">
              <b-form-input class="slide-up" id="lunganta" v-model="formData.step2.lunganta" :state="state.lunganta" type="number" placeholder="Lunghezza Anta"/><label for="lunganta">Lunghezza Anta</label>
              <br>
              <br>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-input class="slide-up" id="docmanufatto" v-model="formData.step2.docmanufatto" :state="state.docmanufatto" placeholder="Numero Documento di Prestazione" /><label for="docmanufatto">Numero Documento di Prestazione</label>
              <br>
              <br>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <b-form-select class="slide-up" id="idCostruttore" v-model="formData.step2.idCostruttore" :options="option.costruttore" :state="state.idCostruttore" placeholder="Seleziona il costruttore del manufatto" /><label for="idCostruttore">* Costruttore</label>
              <br>
              <br>
              <br>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="4" cols="12">
              <b-form-checkbox v-model="formData.step2.marcaturace" :value="true" :unchecked-value="false">Marcatura CE</b-form-checkbox>
              <br>
              <br>
            </b-col>
            <b-col md="4" cols="12">
              <b-form-checkbox v-model="formData.step2.colonnesostegno" :value="true" :unchecked-value="false">Presenza Colonne Sostegno</b-form-checkbox>
              <br>
              <br>
            </b-col>
            <b-col md="4" cols="12">
              <b-form-checkbox v-model="formData.step2.esistedocmanufatto" :value="true" :unchecked-value="false">Esistenza Documentazione Manufatto</b-form-checkbox>
              <br>
              <br>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="4" cols="12">
              <b-form-checkbox v-model="formData.step2.motorizzazione" :value="true" :unchecked-value="false">Predisposizione alla Motorizzazione</b-form-checkbox>
              <br>
              <br>
            </b-col>
            <b-col md="4" cols="12">
              <b-form-checkbox v-model="formData.step2.esemplareunico" :value="true" :unchecked-value="false">Esemplare unico</b-form-checkbox>
              <br>
              <br>
            </b-col>
            <b-col md="4" cols="12">
              <b-form-checkbox v-model="formData.step2.calcolistrutturali" :value="true" :unchecked-value="false">Calcoli strutturali</b-form-checkbox>
              <br>
              <br>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <b-form-group label="Manutenzione a carico di:">
                <b-form-radio v-model="formData.step2.manutenzione" :value="null">Non definito</b-form-radio>
                <b-form-radio v-model="formData.step2.manutenzione" :value="false">Installatore</b-form-radio>
                <b-form-radio v-model="formData.step2.manutenzione" :value="true">Costruttore</b-form-radio>
              </b-form-group>
              <br>
              <br>
            </b-col>
          </b-row>
        </tab-content>
        <!-- :before-change="step3"--> <!-- TODO: riaggiungere step 3-->
        <tab-content title="Componenti" :before-change="step3">
          <b-row class="separatore_text">
            <b-col>
              <hr>
            </b-col>
            <b-col>
              <h5>COMPONENTI</h5>
            </b-col>
            <b-col>
              <hr>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="5">
              <b-form-group label-cols-sm="2" label="Cerca">
                <b-input-group>
                  <b-form-input v-model="componenti.filter" placeholder="Cerca" />
                  <b-input-group-append>
                    <b-button :disabled="!componenti.filter" @click="componenti.filter = ''"><font-awesome-icon icon="times-circle" /></b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col>
              <b-button variant="success" style="float: right" :to="'/elenco/componenti/aggiungi/'+idMacchina"><font-awesome-icon icon="plus-circle" /> Crea Nuovo Componente</b-button>
            </b-col>
            <b-col>
              <b-button variant="success" style="float: right" v-on:click="openModalListaComponente()"><font-awesome-icon icon="file-alt" /> Inserisci Componente Macchina</b-button>
            </b-col>
          </b-row>
          <b-row>
            <b-table
              :striped="true"
              :hover="true"
              :responsive="true"
              :items="formData.step3.componenti"
              :fields="componenti.campi"
              :current-page="componenti.currentPage"
              :per-page="componenti.perPage"
              :filter="componenti.filter"
              @filtered="onFiltered"
            >
              <template slot="action" slot-scope="row">
                <b-button size="sm" variant="danger" v-on:click="openModalDeleteComponente(row.item)"><font-awesome-icon icon="trash-alt" /></b-button>
                <b-button size="sm" style="margin-left: 10px;" v-on:click="openModalEditComponente(row.item)"><font-awesome-icon icon="edit" /></b-button>
              </template>
            </b-table>
          </b-row>
          <b-row>
            <b-col>
              <b-pagination
                :total-rows="componenti.totalRows"
                :per-page="componenti.perPage"
                v-model="componenti.currentPage"
                align="center"
              />
            </b-col>
          </b-row>
        </tab-content>
        <!-- :before-change="step4"--> <!-- TODO: riaggiungere step 4-->
        <tab-content title="Modelli Tecnici" :before-change="step4">
          <b-row class="separatore_text">
            <b-col>
              <hr>
            </b-col>
            <b-col>
              <h5>MODELLI TECNICI</h5>
            </b-col>
            <b-col>
              <hr>
            </b-col>
          </b-row>
          <b-row>
            <b-table
              :striped="true"
              :hover="true"
              :responsive="true"
              :items="docmanufattolist"
              :fields="docmanufatto.modtecnici.campi"
              :current-page="docmanufatto.modtecnici.currentPage"
              :per-page="docmanufatto.modtecnici.totalRows"
            >
              <template slot="action" slot-scope="row">
                <b-button size="sm" variant="success" v-on:click="selectModello(row.item)" :disabled="row.item.loading">
                  <font-awesome-icon v-if="!row.item.loading" icon="check" />
                  <div v-if="row.item.loading" style="margin: 0;" class="sk-cube-grid">
                    <div class="sk-cube sk-cube1"></div>
                    <div class="sk-cube sk-cube2"></div>
                    <div class="sk-cube sk-cube3"></div>
                    <div class="sk-cube sk-cube4"></div>
                    <div class="sk-cube sk-cube5"></div>
                    <div class="sk-cube sk-cube6"></div>
                    <div class="sk-cube sk-cube7"></div>
                    <div class="sk-cube sk-cube8"></div>
                    <div class="sk-cube sk-cube9"></div>
                  </div>
                </b-button>
              </template>
            </b-table>
          </b-row>
          <b-row class="separatore_text">
            <b-col>
              <hr>
            </b-col>
            <b-col>
              <h5>DOCUMENTI TECNICI GENERATI</h5>
            </b-col>
            <b-col>
              <hr>
            </b-col>
          </b-row>
          <b-row style="min-height: 300px;">
            <b-table
              :striped="true"
              :hover="true"
              :responsive="true"
              :items="formData.step4.modelli"
              :fields="docmanufatto.doctecnici.campi"
              :current-page="docmanufatto.doctecnici.currentPage"
              :per-page="docmanufatto.doctecnici.totalRows"
            >
              <template slot="nomefile" slot-scope="row">
                <b-form-input v-model="row.item.nomefile" type="text" placeholder="Nome del documento"/>
              </template>
              <template slot="note" slot-scope="row">
                <b-form-input v-model="row.item.note" type="text" placeholder="Note del documento"/>
              </template>
              <template slot="action" slot-scope="row">
                <b-dropdown id="dropdown-dropleft" variant="primary">
                  <template slot="button-content">
                    <font-awesome-icon icon="cog" />
                  </template>
                  <b-dropdown-item v-on:click="removeModello(row.item)"><font-awesome-icon icon="trash-alt" /> Elimina</b-dropdown-item>
                  <b-dropdown-divider></b-dropdown-divider>
                  <b-dropdown-item v-on:click="downloadModelloCompilato(row.item)"><font-awesome-icon icon="file-download" /> Scarica documento</b-dropdown-item>
                  <b-dropdown-divider></b-dropdown-divider>
                  <b-dropdown-item v-on:click="openModalCaricaModello(row.item)"><font-awesome-icon icon="file-upload" /> Carica documento</b-dropdown-item>
                  <b-dropdown-item v-on:click="downloadModelloCaricato(row.item)" :disabled="!row.item.caricato"><font-awesome-icon icon="file-export" /> Scarica documento caricato</b-dropdown-item>
                  <b-dropdown-item v-on:click="eliminaModelloCaricato(row.item)" :disabled="!row.item.caricato"><font-awesome-icon icon="file-excel" /> Elimina documento caricato</b-dropdown-item>
                  <b-dropdown-divider></b-dropdown-divider>
                  <b-dropdown-item v-on:click="downloadTecnico(row.item.idModello)"><font-awesome-icon icon="file-pdf" /> Scarica in PDF</b-dropdown-item>
                </b-dropdown>
                <!--b-button size="sm" variant="danger" v-on:click="removeModello(row.item)"><font-awesome-icon icon="trash-alt" /></b-button-->
              </template>
            </b-table>
          </b-row>
        </tab-content>
        <!-- :before-change="step5"--> <!-- TODO: riaggiungere step 5-->
        <tab-content title="Documenti Generici" :before-change="step5">
          <b-row class="separatore_text">
            <b-col>
              <hr>
            </b-col>
            <b-col>
              <h5>DOCUMENTI GENERICI</h5>
            </b-col>
            <b-col>
              <hr>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" md="10">
              <file-pond :files="documenti.file" ref="pond" label-idle="* Clicca qui o trascina il documento da caricare" allow-multiple="false" max-files="1"/>
            </b-col>
            <b-col cols="12" md="2">
              <b-button size="lg" variant="primary" v-on:click="addDocumento()" :disabled="buttonState.documento_generale">
                <font-awesome-icon icon="file-upload" /> Carica
                <div v-if="buttonState.documento_generale" class="sk-cube-grid">
                  <div class="sk-cube sk-cube1"></div>
                  <div class="sk-cube sk-cube2"></div>
                  <div class="sk-cube sk-cube3"></div>
                  <div class="sk-cube sk-cube4"></div>
                  <div class="sk-cube sk-cube5"></div>
                  <div class="sk-cube sk-cube6"></div>
                  <div class="sk-cube sk-cube7"></div>
                  <div class="sk-cube sk-cube8"></div>
                  <div class="sk-cube sk-cube9"></div>
                </div>
              </b-button>
            </b-col>
          </b-row>
          <b-row>
            <b-table
              :striped="true"
              :hover="true"
              :responsive="true"
              :items="formData.step5.documenti"
              :fields="documenti.campi"
              :current-page="documenti.currentPage"
              :per-page="documenti.totalRows"
            >
              <template slot="nomefile" slot-scope="row">
                <b-form-input v-model="row.item.nomefile" type="text" placeholder="Nome del documento"/>
              </template>
              <template slot="note" slot-scope="row">
                <b-form-input v-model="row.item.note" type="text" placeholder="Note del documento"/>
              </template>

              <template slot="attivo" slot-scope="row">
                <b-form-checkbox v-model="row.item.attivo" :value="true" :unchecked-value="false"></b-form-checkbox>
              </template>

              <template slot="action" slot-scope="row">
                <b-button size="sm" variant="success" v-on:click="downloadGenerale(row.item)"><font-awesome-icon icon="file-download" /></b-button>
                <b-button size="sm" variant="danger" style="margin-left: 10px;" v-on:click="openModalDeleteDocumento(row.item)"><font-awesome-icon icon="trash-alt" /></b-button>
              </template>
            </b-table>
          </b-row>
        </tab-content>
        <!-- :before-change="step6"--> <!-- TODO: riaggiungere step 6-->
        <tab-content title="Riepilogo" :before-change="step6">
          <b-row>
            <b-col cols="12" offset-md="6" md="6">
              <b-row>
                <b-col cols="12" md="4">
                  <b-button size="sm"  variant="success" v-on:click="selezionaTutto()">Seleziona tutto <font-awesome-icon icon="check-square" /></b-button>
                </b-col>
                <b-col cols="12" md="4">
                  <b-button size="sm" variant="danger" v-on:click="deselezionaTutto()">Deseleziona tutto <font-awesome-icon icon="check-square" /></b-button>
                </b-col>
                <b-col cols="12" md="4">
                  <b-button size="sm" variant="info" v-on:click="loadRiepilogo()">Ripristina <font-awesome-icon icon="redo-alt" /></b-button>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <b-row class="separatore_text">
            <b-col>
              <hr>
            </b-col>
            <b-col>
              <h5>DOCUMENTI TECNICI</h5>
            </b-col>
            <b-col>
              <hr>
            </b-col>
          </b-row>
          <b-row>
            <b-table
              :striped="true"
              :hover="true"
              :responsive="true"
              :items="formData.step6.riepilogo.docmanufatto"
              :fields="riepilogo.docmanufatto.campi"
              :current-page="riepilogo.docmanufatto.currentPage"
              :per-page="riepilogo.docmanufatto.totalRows"
            >
              <template slot="originalname" slot-scope="row">
                <p class="col_text_cut">{{row.value}}</p>
              </template>
              <template slot="nomefile" slot-scope="row">
                <p class="col_text_cut">{{row.value}}</p>
              </template>
              <template slot="note" slot-scope="row">
                <p class="col_text_cut">{{row.value}}</p>
              </template>

              <template slot="stampa" slot-scope="row">
                <b-form-checkbox v-model="row.item.stampa" :value="true" :unchecked-value="false"></b-form-checkbox>
              </template>

              <template slot="action" slot-scope="row">
                <b-button size="sm" variant="success" v-on:click="downloadTecnico(row.item.id)"><font-awesome-icon icon="file-download" /></b-button>
              </template>
            </b-table>
            <br>
            <br>
          </b-row>

          <b-row class="separatore_text">
            <b-col>
              <hr>
            </b-col>
            <b-col>
              <h5>ALLEGATI TECNICI COMPONENTI</h5>
            </b-col>
            <b-col>
              <hr>
            </b-col>
          </b-row>
          <b-row>
            <b-table
              :striped="true"
              :hover="true"
              :responsive="true"
              :items="formData.step6.riepilogo.doccomponente"
              :fields="riepilogo.doccomponente.campi"
              :current-page="riepilogo.doccomponente.currentPage"
              :per-page="riepilogo.doccomponente.totalRows"
            >
              <template slot="originalname" slot-scope="row">
                <p class="col_text_cut">{{row.value}}</p>
              </template>
              <template slot="nomefile" slot-scope="row">
                <p class="col_text_cut">{{row.value}}</p>
              </template>
              <template slot="note" slot-scope="row">
                <p class="col_text_cut">{{row.value}}</p>
              </template>

              <template slot="stampa" slot-scope="row">
                <b-form-checkbox v-model="row.item.stampa" :value="true" :unchecked-value="false"></b-form-checkbox>
              </template>

              <template slot="action" slot-scope="row">
                <b-button size="sm" variant="success" v-on:click="downloadComponente(row.item)"><font-awesome-icon icon="file-download" /></b-button>
              </template>
            </b-table>
            <br>
            <br>
          </b-row>

          <b-row class="separatore_text">
            <b-col>
              <hr>
            </b-col>
            <b-col>
              <h5>ALLEGATI GENERICI</h5>
            </b-col>
            <b-col>
              <hr>
            </b-col>
          </b-row>
          <b-row>
            <b-table
              :striped="true"
              :hover="true"
              :responsive="true"
              :items="formData.step6.riepilogo.docgenerali"
              :fields="riepilogo.docgenerali.campi"
              :current-page="riepilogo.docgenerali.currentPage"
              :per-page="riepilogo.docgenerali.totalRows"
            >
              <template slot="originalname" slot-scope="row">
                <p class="col_text_cut">{{row.value}}</p>
              </template>
              <template slot="nomefile" slot-scope="row">
                <p class="col_text_cut">{{row.value}}</p>
              </template>
              <template slot="note" slot-scope="row">
                <p class="col_text_cut">{{row.value}}</p>
              </template>

              <template slot="stampa" slot-scope="row">
                <b-form-checkbox v-model="row.item.stampa" :value="true" :unchecked-value="false"></b-form-checkbox>
              </template>

              <template slot="action" slot-scope="row">
                <b-button size="sm" variant="success" v-on:click="downloadGenerale(row.item)"><font-awesome-icon icon="file-download" /></b-button>
              </template>
            </b-table>
            <br>
            <br>
          </b-row>
        </tab-content>
      </form-wizard>
    </b-container>

    <b-modal v-model="modal.indirizzo" size="xl" title="Seleziona un indirizzo">
      <b-row>
        <b-col md="5">
          <b-form-group label-cols-sm="2" label="Cerca">
            <b-input-group>
              <b-form-input v-model="filter" placeholder="Cerca" />
              <b-input-group-append>
                <b-button :disabled="!filter" @click="filter = ''"><font-awesome-icon icon="times-circle" /></b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-table
          :striped="true"
          :hover="true"
          :responsive="true"
          :items="option.cliente_indirizzi"
          :fields="campi"
          :current-page="currentPage"
          :per-page="perPage"
          :filter="filter"
          @filtered="onFiltered"
        >
          <template slot="action" slot-scope="row">
            <b-button size="sm" variant="success" v-on:click="selectIndirizzo(row.item)"><font-awesome-icon icon="check" /></b-button>
          </template>

          <template slot="residenza" slot-scope="row">
            <p v-if="row.item.residenza"><font-awesome-icon icon="home" /> Residenza</p>
            <p v-if="!row.item.residenza"><font-awesome-icon icon="map-marker-alt" /> Ubicazione</p>
          </template>

          <template slot="indirizzo" slot-scope="row">
            {{row.item.via}} {{row.item.civico}}, {{row.item.cap}} {{row.item.comune}}({{row.item.provincia}}), {{row.item.nazione}}
          </template>
        </b-table>
      </b-row>
      <b-row>
        <b-col>
          <b-pagination
            :total-rows="totalRows"
            :per-page="perPage"
            v-model="currentPage"
            align="center"
          />
        </b-col>
      </b-row>
      <div slot="modal-footer">
        <b-button class="float-right" v-on:click="modal.indirizzo = false">Annulla</b-button>
      </div>
    </b-modal>

    <b-modal v-model="modal.aggiungi_componente" size="xl" :title="((this.buttonState.modifica_componente) ? 'Modifica un componente' : 'Aggiungi un componente')">
      <b-row>
        <b-col md="5">
          <b-form-group label-cols-sm="2" label="Cerca">
            <b-input-group>
              <b-form-input v-model="aggiungi_componenti.filter" placeholder="Cerca" />
              <b-input-group-append>
                <b-button :disabled="!aggiungi_componenti.filter" @click="aggiungi_componenti.filter = ''"><font-awesome-icon icon="times-circle" /></b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-table
          :striped="true"
          :hover="true"
          :responsive="true"
          :items="aggiungi_componenti.elenco"
          :fields="aggiungi_componenti.campi"
          :current-page="aggiungi_componenti.currentPage"
          :per-page="aggiungi_componenti.perPage"
          :filter="aggiungi_componenti.filter"
          @filtered="onFilteredAggiungiComponente"
        >
          <template slot="action" slot-scope="row">
            <b-button size="sm" variant="success" v-on:click="selectComponente(row.item)" :disabled="row.item.loading"><font-awesome-icon icon="check" /></b-button>
          </template>
        </b-table>
      </b-row>
      <b-row>
        <b-col>
          <b-pagination
            :total-rows="aggiungi_componenti.totalRows"
            :per-page="aggiungi_componenti.perPage"
            v-model="aggiungi_componenti.currentPage"
            align="center"
          />
        </b-col>
      </b-row>
      <b-row class="separatore_text">
        <b-col>
          <hr>
        </b-col>
        <b-col>
          <h5>INFO COMPONENTE</h5>
        </b-col>
        <b-col>
          <hr>
        </b-col>
      </b-row>
      <b-row id="box_info_componente">
        <b-col>
          <strong>Codice Catalogo:</strong> {{aggiungi_componenti.elemento_selezionato.codcatalogo}}<br>
          <strong>Marca:</strong> {{aggiungi_componenti.elemento_selezionato["marca.nome"]}}<br>
        </b-col>
        <b-col>
          <strong>Tipologia Componente:</strong> {{aggiungi_componenti.elemento_selezionato["tipocomponente.nome"]}}<br>
          <strong>Sottotipologia Componente:</strong> {{aggiungi_componenti.elemento_selezionato["sottotipocomponente.nome"]}}<br>
        </b-col>
        <b-col cols="12">
          <strong>Descrizione:</strong> {{aggiungi_componenti.elemento_selezionato.descrizione}}<br>
        </b-col>
      </b-row>
      <br>
      <b-row>
        <b-col cols="12">
          <b-form-input class="slide-up" id="quantita" v-model="modalForm.aggiungi_componente.quantita" :state="state.quantita" type="number" placeholder="Indicare in quale quantità è presente questo componente"/><label for="quantita">* Quantità</label>
          <br>
          <br>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <b-form-input class="slide-up" id="numserie" v-model="modalForm.aggiungi_componente.numserie" :state="state.numserie" type="text" placeholder="Inserisci i Numero di Serie dei componenti"/><label for="numserie">Numero Serie</label>
          <br>
          <br>
        </b-col>
      </b-row>
      <div slot="modal-footer">
        <b-button class="float-right" variant="success" style="margin-left: 10px" v-on:click="addListaComponente()">
          <span v-if="this.buttonState.modifica_componente">Aggiorna</span>
          <span v-else>Aggiungi</span>
        </b-button>
        <b-button class="float-right" v-on:click="modal.aggiungi_componente = false">Annulla</b-button>
      </div>
    </b-modal>

    <b-modal v-model="modal.componente" size="xl" title="Aggiungi un componente">
      <b-row>
        <b-col cols="12">
          <b-form-input class="slide-up" id="codcatalogo" v-model="modalForm.componente.codcatalogo" type="text" placeholder="Codice componente da catalogo"/><label for="codcatalogo">* Codice Catalogo</label>
          <br>
          <br>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <b-form-select class="slide-up" id="idMarca" v-model="modalForm.componente.idMarca" :options="option.marche" placeholder="Seleziona la marca del componente" /><label for="idMarca">* Marca</label>
          <br>
          <br>
          <br>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <b-form-input class="slide-up" id="quantita" v-model="modalForm.componente.quantita" type="number" placeholder="Indicare in quale quantità è presente questo componente"/><label for="quantita">* Quantità</label>
          <br>
          <br>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <b-form-input class="slide-up" id="numserie" v-model="modalForm.componente.numserie" type="text" placeholder="Numero di Serie"/><label for="numserie">Numero Serie</label>
          <br>
          <br>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <b-form-select class="slide-up" id="idTipocomponente" v-model="modalForm.componente.idTipocomponente" :options="option.tipocomponente" placeholder="Seleziona una tipologia di componente" /><label for="idTipocomponente">* Tipologia di componente</label>
          <br>
          <br>
          <br>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <b-form-select class="slide-up" id="idSottotipocomponente" v-model="modalForm.componente.idSottotipocomponente" :options="option.sottotipocomponente" placeholder="Seleziona una sotto tipologia di componente" /><label for="idSottotipocomponente">* Sotto tipologia di componente</label>
          <br>
          <br>
          <br>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-textarea class="slide-up" id="descrizione" v-model="modalForm.componente.descrizione" rows="3" max-rows="6" /><label for="descrizione">Descrizione</label>
          <br>
          <br>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-textarea class="slide-up" id="note" v-model="modalForm.componente.note" rows="3" max-rows="6" /><label for="note">Note</label>
          <br>
          <br>
        </b-col>
      </b-row>
      <b-row class="separatore_text">
        <b-col>
          <hr>
        </b-col>
        <b-col>
          <h5>DOCUMENTI COMPONENTE</h5>
        </b-col>
        <b-col>
          <hr>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <h6>Documento 1</h6>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-file v-model="modalForm.componente_file.file1" placeholder="Seleziona un documento" accept=".docx, .pdf"></b-form-file>
          <br>
          <br>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <h6>Documento 2</h6>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-file v-model="modalForm.componente_file.file2" placeholder="Seleziona un documento" accept=".docx, .pdf"></b-form-file>
          <br>
          <br>
        </b-col>
      </b-row>
      <div slot="modal-footer">
        <b-button class="float-right" variant="success" style="margin-left: 10px" v-on:click="addComponente()" :disabled="buttonState.componenti">
          Aggiungi
          <div v-if="buttonState.componenti" class="sk-cube-grid">
            <div class="sk-cube sk-cube1"></div>
            <div class="sk-cube sk-cube2"></div>
            <div class="sk-cube sk-cube3"></div>
            <div class="sk-cube sk-cube4"></div>
            <div class="sk-cube sk-cube5"></div>
            <div class="sk-cube sk-cube6"></div>
            <div class="sk-cube sk-cube7"></div>
            <div class="sk-cube sk-cube8"></div>
            <div class="sk-cube sk-cube9"></div>
          </div>
        </b-button>
        <b-button class="float-right" v-on:click="modal.componente = false">Annulla</b-button>
      </div>
    </b-modal>

    <b-modal v-model="modal.riepilogo" size="xl" title="Genera pacchetto">
      <b-row>
        <b-col cols="12">
          <b-form-input class="slide-up" id="nomefile" v-model="formData.step6.info_pacchetto.nomefile" type="text" placeholder="Nome del pacchettp"/><label for="nomefile">* Nome Pacchetto</label>
          <br>
          <br>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <b-form-textarea class="slide-up" id="note" v-model="formData.step6.info_pacchetto.note" rows="3" max-rows="6" /><label for="note">Note</label>
          <br>
          <br>
          <br>
        </b-col>
      </b-row>
      <div slot="modal-footer">
        <b-button class="float-right" variant="success" style="margin-left: 10px" v-on:click="generaPacchetto()" :disabled="buttonState.genera">
          Genera pacchetto
          <div v-if="buttonState.genera" class="sk-cube-grid">
            <div class="sk-cube sk-cube1"></div>
            <div class="sk-cube sk-cube2"></div>
            <div class="sk-cube sk-cube3"></div>
            <div class="sk-cube sk-cube4"></div>
            <div class="sk-cube sk-cube5"></div>
            <div class="sk-cube sk-cube6"></div>
            <div class="sk-cube sk-cube7"></div>
            <div class="sk-cube sk-cube8"></div>
            <div class="sk-cube sk-cube9"></div>
          </div>
        </b-button>
        <b-button class="float-right" v-on:click="modal.riepilogo = false">Annulla</b-button>
      </div>
    </b-modal>

    <b-modal v-model="modal.delete" title="Si vuole eliminare il seguente componente?">
      <p>Sei sicuro di voler eliminare il seguente componente:</p>
      <br>
      <strong>-> {{modalForm.delete.codcatalogo}}</strong>
      <div slot="modal-footer">
        <b-button class="float-right" variant="danger" style="margin-left: 10px" v-on:click="deleteComponente(modalForm.delete.id)">Elimina</b-button>
        <b-button class="float-right" v-on:click="modal.delete = false">Annulla</b-button>
      </div>
    </b-modal>

    <b-modal v-model="modal.delete_doc" title="Si vuole eliminare il seguente pacchetto?">
      <p>Sei sicuro di voler eliminare il seguente documento:</p>
      <br>
      <strong>-> {{modalForm.delete_doc.originalname}}</strong>
      <div slot="modal-footer">
        <b-button class="float-right" variant="danger" style="margin-left: 10px" v-on:click="deleteDocumento(modalForm.delete_doc.id)">Elimina</b-button>
        <b-button class="float-right" v-on:click="modal.delete_doc = false">Annulla</b-button>
      </div>
    </b-modal>

    <b-modal v-model="modal.carica_modello" title="Carica un Documento">
      <p>Seleziona un documento da caricare</p>
      <br>
      <file-pond :files="modello.file" ref="carica_modello" label-idle="* Clicca qui o trascina il documento da caricare" allow-multiple="false" max-files="1"/>
      <div slot="modal-footer">
        <b-button class="float-right" variant="success" style="margin-left: 10px" :disabled="buttonState.carica_modello" v-on:click="caricaModello(modalForm.carica_modello.idModello)">
          Carica
          <div v-if="buttonState.carica_modello" class="sk-cube-grid">
            <div class="sk-cube sk-cube1"></div>
            <div class="sk-cube sk-cube2"></div>
            <div class="sk-cube sk-cube3"></div>
            <div class="sk-cube sk-cube4"></div>
            <div class="sk-cube sk-cube5"></div>
            <div class="sk-cube sk-cube6"></div>
            <div class="sk-cube sk-cube7"></div>
            <div class="sk-cube sk-cube8"></div>
            <div class="sk-cube sk-cube9"></div>
          </div>
        </b-button>
        <b-button class="float-right" v-on:click="modal.carica_modello = false">Annulla</b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Vue from 'vue'
import vueFilePond from 'vue-filepond'
import 'filepond/dist/filepond.min.css'
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css'
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type'
import FilePondPluginImagePreview from 'filepond-plugin-image-preview'
import { globalConf } from '../../config.global'

const FilePond = vueFilePond(FilePondPluginFileValidateType, FilePondPluginImagePreview)

var map
var markers

export default {
  name: 'macchineadd',
  components: {
      FilePond
  },
  data() {
    return {
      idMacchina: null,
      campi: [
        {key: 'indirizzo', label: 'Indirizzo', sortable: true},
        {key: 'residenza', label: 'Residenza/Ubicazione', sortable: true}, 
        {key: 'princ_nome', label: 'Referente', sortable: true},
        {key: 'princ_cellulare', label: 'Cellulare', sortable: true},
        {key: 'princ_telefono', label: 'Telefono', sortable: true},
        {key: 'princ_email', label: 'Email', sortable: true},
        //{key: 'note', label: 'Note', sortable: true},
        {key: 'action', label: '', sortable: false}
      ],
      totalRows: 0,
      currentPage: 1,
      perPage: 10,
      filter: null,

      /* DOCUMENTI MANUFATTO */
      docmanufatto: {
        modtecnici:{
          campi: [
            {key: 'modtecnico', label: 'Modello tecnico', sortable: true},
            {key: 'nomefile', label: 'Nome file', sortable: true},
            {key: 'action', label: '', sortable: false}
          ],
          totalRows: 0,
          currentPage: 1,
        },
        doctecnici: {
          campi: [
            {key: 'modtecnico', label: 'Modello tecnico', sortable: true},
            {key: 'nomefile', label: 'Nome file', sortable: true},
            {key: 'note', label: 'Note', sortable: true},
            {key: 'action', label: '', sortable: false}//TODO: aggiungere caricamentro di un altro documento
          ],
          totalRows: 0,
          currentPage: 1,
          perPage: 10,
          filter: null,
        }
      },
      /* COMPONENTI */
      aggiungi_componenti: {
        campi: [
          {key: 'codcatalogo', label: 'Codice Catalogo', sortable: true},
          {key: 'marca.nome', label: 'Marca', sortable: true},
          {key: 'tipocomponente.nome', label: 'Tipologia Componente', sortable: true},
          {key: 'sottotipocomponente.nome', label: 'Sottotipologia Componente', sortable: true},
          {key: 'descrizione', label: 'Descrizione', sortable: true},
          {key: 'action', label: '', sortable: false}
        ],
        totalRows: 0,
        perPage: 5,
        currentPage: 1,
        filter: null,
        elenco: [],
        elemento_selezionato: {}
      },

      componenti: {
        campi: [
          {key: 'codcatalogo', label: 'Codice Catalogo', sortable: true},
          {key: 'marca', label: 'Marca', sortable: true},
          {key: 'quantita', label: 'Quantità', sortable: true},
          {key: 'numserie', label: 'Numero di Serie', sortable: true},
          {key: 'tipocomponente', label: 'Componente', sortable: true},
          {key: 'sottotipocomponente', label: 'Sottotipologia di Componente', sortable: true},
          {key: 'categoria', label: 'Categoria Componente', sortable: true},
          //{key: 'descrizione', label: 'Descrizione', sortable: true},
          //{key: 'note', label: 'Note', sortable: true},
          {key: 'action', label: '', sortable: false}
        ],
        totalRows: 0,
        perPage: 10,
        currentPage: 1,
      },
      /* DOCUMENTI */
      documenti: {
        campi: [
            {key: 'originalname', label: 'Nome file originale', sortable: true},
            {key: 'nomefile', label: 'Nome file', sortable: true},
            {key: 'note', label: 'Note', sortable: true},
            {key: 'attivo', label: 'Includi', sortable: false},
            {key: 'action', label: '', sortable: false}
        ],
        totalRows: 0,
        perPage: 10,
        currentPage: 1,
        file: []
      },

      /* RIEPILOGO */
      riepilogo: {
        docgenerali:{
          campi: [
              {key: 'originalname', label: 'Documento', sortable: true, class: 'table_size_col1'},
              {key: 'nomefile', label: 'Nome file', sortable: true, class: 'table_size_col2'},
              {key: 'note', label: 'Note', sortable: true, class: 'table_size_col3'},
              {key: 'stampa', label: 'Includi', sortable: false, class: 'table_size_col4'},
              {key: 'action', label: '', sortable: false, class: 'table_size_col5'}
          ],
          totalRows: 0,
          perPage: 10,
          currentPage: 1
        },
        docmanufatto: {
          campi: [
              {key: 'originalname', label: 'Documento', sortable: true, class: 'table_size_col1'},
              {key: 'nomefile', label: 'Nome file', sortable: true, class: 'table_size_col2'},
              {key: 'note', label: 'Note', sortable: true, class: 'table_size_col3'},
              {key: 'stampa', label: 'Includi', sortable: false, class: 'table_size_col4'},
              {key: 'action', label: '', sortable: false, class: 'table_size_col5'}
          ],
          totalRows: 0,
          perPage: 10,
          currentPage: 1
        },
        doccomponente: {
          campi: [
              {key: 'originalname', label: 'Documento', sortable: true, class: 'table_size_col1'},
              {key: 'codcatalogo', label: 'Codice Componente', sortable: true, class: 'table_size_col3'},
              {key: 'descrizione', label: 'Descrizione Componente', sortable: true, class: 'table_size_col2'},
              {key: 'stampa', label: 'Includi', sortable: false, class: 'table_size_col4'},
              {key: 'action', label: '', sortable: false, class: 'table_size_col5'}
          ],
          totalRows: 0,
          perPage: 10,
          currentPage: 1
        }
      },

      state: {
        /* MACCHINA */
        codprodotto: null,
        idCliente: null,
        search_address: null,
        princ_nome: null,
        princ_cellulare: null,
        princ_telefono: null,
        princ_email: null,
        princ_indirizzo: null,
        referente1: null,
        email1: null,
        cellulare1: null,
        telefono1: null,
        referente2: null,
        email2: null,
        cellulare2: null,
        telefono2: null,
        descrizione: null,
        datainstallazione: null,
        datacollaudo: null,
        manutenzionecliente: null,
        iniziogaranzia: null,
        finegaranzia: null,
        estensionegaranzia: null,
        note: null,
        docprestazione: null,
        passcentrale: null,
        freqmanutenzione: null,
        descimpianto: null,
        proprietario: null,
        idTipomacchina: null,
        idTipoelettrico: null,
        /* MANUFATTO */
        idTipomanufatto: null,
        idTipoutilizzo: null,
        idTipouso: null,
        idTipotamponamento: null,
        datainstallazione: null,
        datapresaincarico: null,
        matrmanufatto: null,
        classevetro: null,
        docmanufatto: null,
        dimluce: null,
        peso: null,
        lunganta: null,
        altezza: null,
        numante: null,
        idCostruttore: null,
        /* COMPONENTE */
        quantita: null,
        numserie: null
      },
      option: {
        clienti:[],
        cliente_indirizzi: [],
        tipomacchina: [],
        tipoelettrico: [],
        tipomanufatto: [],
        tipoutilizzo: [],
        tipouso: [],
        tipotamponamento: [],
        docmanufatto: [],
        marche: [],
        tipocomponente: [],
        sottotipocomponente: [],
        costruttore: [],
        tipoluogo: []
      },
      formData:{
        step1:{
          codprodotto: '',
          idCliente: null,
          idTipoluogo: null,
          via: '',
          civico: '',
          nazione: '',
          provincia: '',
          comune: '',
          cap: '',
          princ_nome: '',
          princ_cellulare: '',
          princ_telefono: '',
          princ_email: '',
          princ_indirizzo: '',
          referente1: '',
          email1: '',
          cellulare1: '',
          telefono1: '',
          referente2: '',
          email2: '',
          cellulare2: '',
          telefono2: '',
          descrizione: '',
          datainstallazione: null,
          datacollaudo: null,
          manutenzionecliente: false,
          iniziogaranzia: null,
          finegaranzia: null,
          estensionegaranzia: null,
          note: null,
          docprestazione: '',
          passcentrale: '',
          freqmanutenzione: '',
          descimpianto: '',
          proprietario: '',
          idTipomacchina: null,
          idTipoelettrico: null,
        },
        step2: {
          idTipomanufatto: null,
          idTipoutilizzo: null,
          idTipouso: null,
          idTipotamponamento: null,
          datainstallazione: null,
          datapresaincarico: null,
          matrmanufatto: '',
          classevetro: '',
          docmanufatto: '',
          dimluce: null,
          peso: null,
          lunganta: null,
          altezza: null,
          numante: null,
          marcaturace: false,
          colonnesostegno: false,
          esistedocmanufatto: false,
          motorizzazione: false,
          esemplareunico: false,
          calcolistrutturali: false,
          manutenzione: null,
          idCostruttore: null
        },
        step4: {
          modelli: [],
        },
        step3: {
          componenti: [],
        },
        step5: {
          documenti: []
        },
        step6:{
          riepilogo: [],
          info_pacchetto: {
            nomefile: '',
            note: ''
          }
        }
      },
      modal: {
        indirizzo: false,
        aggiungi_componente: false,
        componente: false,
        riepilogo: false,
        delete: false,
        delete_doc: false,
        carica_modello: false
      },
      modalForm: {
        delete: {},
        delete_doc: {},
        aggiungi_componente: {
          idComponente: null,
          quantita: null,
          numserie: ''
        },
        componente: {
          codcatalogo: '',
          idMarca: null,
          quantita: null,
          numserie: '',
          idTipocomponente: null,
          idSottotipocomponente: null,
          descrizione: '',
          note: ''
        },
        componente_file: {
          file1: null,
          file2: null
        },
        carica_modello: {}
      },
      buttonState: {
        componenti: false,
        documento_generale: false,
        carica_modello: false,
        modifica_componente: false,
        genera: false
      },
      modello: {
        file: []
      }
    }
  },
  computed: {
    docmanufattolist: {
      // getter
      get: function () {
        return this.option.docmanufatto.filter(e => {
          if(this.formData.step4.modelli.map(el => el.idModello).indexOf(e.idModello) != -1)
            return false
          return true
        })
      },
      // setter
      set: function (newValue) {
      }
    }
  },
  created: function(){
    this.option.costruttore = this.getListOption("costruttore")
    this.option.clienti = this.getListOption("clienti")
    this.option.tipomacchina = this.getListOption("tipomacchine")
    this.option.tipoelettrico = this.getListOption("tipoelettrici")
    this.option.tipomanufatto = this.getListOption("tipomanufatti")
    this.option.tipoutilizzo = this.getListOption("tipoutilizzi")
    this.option.tipouso = this.getListOption("tipousi")
    this.option.tipotamponamento = this.getListOption("tipotamponamenti")
    this.option.tipoluogo = this.getListOption("tipoluogo")


    Vue.loadScript("https://maps.googleapis.com/maps/api/js?key="+globalConf.gmaps+"&libraries=places")
    .then(() => {
      this.loadMap()
    })
    .catch(() => {
      console.log("Errore durante il caricamento di Google Maps!")
    })
  },
   watch: {
    'modalForm.componente.idTipocomponente': function(val){
      this.modalForm.componente.idSottotipocomponente = null

      if(val != null)
        this.option.sottotipocomponente = this.getListOption("sottotipocomponente/"+val)
      else
        this.option.sottotipocomponente = []
    }
  },
  methods: {
    /* STEP CHECK */
    step1(){
      return Vue.http.post('macchina/step1'+((this.idMacchina) ? "/"+this.idMacchina : ""), {step1: this.formData.step1}, {credentials : true}).then(response => {
        if(response.body.success){
          this.idMacchina = response.body.idMacchina

          return true
        }else{
          for(var i=0; i<Object.keys(this.state).length; i++){
            this.state[Object.keys(this.state)[i]] = null
          }

          for(var i=0; i<response.body.inputError.length; i++){
            this.state[response.body.inputError[i]] = false
          }
          
          Vue.notify({
              group: 'global',
              title: 'Errore',
              text: response.body.msg,
              type: 'error'
          })
          return false
        }
      }, response => {
        Vue.notify({
            group: 'global',
            title: 'Errore',
            text: "Errore durante l'esecuzione dello step 1!",
            type: 'error'
        })
        
        return false
      })
    },
    step2(){
      if(this.idMacchina == null){
        Vue.notify({
            group: 'global',
            title: 'Errore',
            text: "Macchina non valida!",
            type: 'error'
        })
        return false
      }

      return Vue.http.post('macchina/step2/'+this.idMacchina, {step2: this.formData.step2}, {credentials : true}).then(response => {
        if(response.body.success){
          this.loadListComponente()
          this.option.marche = this.getListOption("marche")
          this.option.tipocomponente = this.getListOption("componente")
          
          return true
        }else{
          for(var i=0; i<Object.keys(this.state).length; i++){
            this.state[Object.keys(this.state)[i]] = null
          }

          for(var i=0; i<response.body.inputError.length; i++){
            this.state[response.body.inputError[i]] = false
          }
          
          Vue.notify({
              group: 'global',
              title: 'Errore',
              text: response.body.msg,
              type: 'error'
          })
          return false
        }
      }, response => {
        Vue.notify({
            group: 'global',
            title: 'Errore',
            text: "Errore durante l'esecuzione dello step 1!",
            type: 'error'
        })
        
        return false
      })
    },
    step3(){
      /*if(this.idMacchina == null){
        Vue.notify({
            group: 'global',
            title: 'Errore',
            text: "Macchina non valida!",
            type: 'error'
        })
        return false
      }*/ //TODO: abilitare dopo test

      this.listModelloSelected()
      return Vue.http.post('selectlist/docmanufatto/'+this.formData.step2.idTipomanufatto, {}, {credentials : true}).then(response => {
        if(response.body.success){
          this.option.docmanufatto = response.body.list.map(e => {
            e.loading = false

            return e
          })
          this.docmanufatto.modtecnici.totalRows = response.body.list.length

          return true
        }else{
          Vue.notify({
              group: 'global',
              title: 'Errore',
              text: "Il Manufatto selezionato non ha Documenti Tecnici associati!",
              type: 'warn'
          })
          return true
        }
      }, response => {
        Vue.notify({
            group: 'global',
            title: 'Errore',
            text: "Errore con il manufatto!",
            type: 'error'
        })
        
        return false
      })
    },
    step4(){
      if(this.idMacchina == null){
        Vue.notify({
            group: 'global',
            title: 'Errore',
            text: "Macchina non valida!",
            type: 'error'
        })
        return false
      }

      return Vue.http.post('macchina/step4/'+this.idMacchina, {step4: this.formData.step4}, {credentials : true}).then(response => {
        if(response.body.success){
          return true
        }else{
          for(var i=0; i<Object.keys(this.state).length; i++){
            this.state[Object.keys(this.state)[i]] = null
          }

          for(var i=0; i<response.body.inputError.length; i++){
            this.state[response.body.inputError[i]] = false
          }
          
          Vue.notify({
              group: 'global',
              title: 'Errore',
              text: response.body.msg,
              type: 'error'
          })
          return false
        }
      }, response => {
        Vue.notify({
            group: 'global',
            title: 'Errore',
            text: "Errore durante l'esecuzione dello step 3!",
            type: 'error'
        })
        
        return false
      })
    },
    step5(){
      /*if(this.idMacchina == null){
        Vue.notify({
            group: 'global',
            title: 'Errore',
            text: "Macchina non valida!",
            type: 'error'
        })
        return false
      }*/ //TODO: abilitare dopo test

      return Vue.http.post('macchina/step5/'+this.idMacchina, {step5: this.formData.step5}, {credentials : true}).then(response => {
        if(response.body.success){
          this.loadRiepilogo()

          return true
        }else{
          /*for(var i=0; i<Object.keys(this.state).length; i++){
            this.state[Object.keys(this.state)[i]] = null
          }

          for(var i=0; i<response.body.inputError.length; i++){
            this.state[response.body.inputError[i]] = false
          }*/
          
          Vue.notify({
              group: 'global',
              title: 'Errore',
              text: response.body.msg,
              type: 'error'
          })
          return false
        }
      }, response => {
        Vue.notify({
            group: 'global',
            title: 'Errore',
            text: "Errore durante l'esecuzione dello step 3!",
            type: 'error'
        })
        
        return false
      })
    },
    step6(){
      /*if(this.idMacchina == null){
        Vue.notify({
            group: 'global',
            title: 'Errore',
            text: "Macchina non valida!",
            type: 'error'
        })
        return false
      }*/ //TODO: abilitare dopo test

      var cliente = this.option.clienti.find(e =>{
        return e.value == this.formData.step1.idCliente
      }).text

      this.formData.step6.info_pacchetto.nomefile = cliente+" - "+this.formData.step1.codprodotto+" - "+this.formData.step1.descrizione
      this.formData.step6.info_pacchetto.nomefile = this.formData.step6.info_pacchetto.nomefile.slice(0, 170)

      this.modal.riepilogo = true

      return true
    },


    downloadGenerale(item){
      window.open(Vue.prototype.$hostlink+"macchina/download/generale/"+this.idMacchina+"/"+item.id)
    },
    downloadComponente(item){
      window.open(Vue.prototype.$hostlink+"macchina/download/componente/"+this.idMacchina+"/"+item.id)
    },
    downloadTecnico(id){
      window.open(Vue.prototype.$hostlink+"macchina/download/tecnico/"+this.idMacchina+"/"+id)
    },
    downloadModelloCompilato(item){
      window.open(Vue.prototype.$hostlink+"macchina/modello/download/"+this.idMacchina+"/"+item.idModello)
    },

    openModalCaricaModello(item){
      this.modalForm.carica_modello = item
      this.modal.carica_modello = true
    },
    caricaModello(idModello){
      if(this.buttonState.carica_modello)
        return
      
      if(this.$refs.carica_modello.getFiles().length == 1){
        this.buttonState.carica_modello = true
        var formSend = new FormData()
        formSend.append('documento', this.$refs.carica_modello.getFiles()[0].file, this.$refs.carica_modello.getFiles()[0].file.name)

        Vue.http.post('macchina/modello/upload/'+this.idMacchina+'/'+idModello, formSend, {credentials : true}).then(response => {
          if(response.body.success){
            this.listModelloSelected()
            this.modal.carica_modello = false
            this.buttonState.carica_modello = false

            this.modello.file = []
          }else{
            this.buttonState.carica_modello = false
            Vue.notify({
                group: 'global',
                title: 'Errore',
                text: response.body.msg,
                type: 'error'
            })
          }
        }, response => {
          Vue.notify({
              group: 'global',
              title: 'Errore',
              text: "Errore!",
              type: 'error'
          })
        })
      }else{
        Vue.notify({
            group: 'global',
            title: 'Errore!',
            text: "Devi selezionare un file!",
            type: 'error'
        })
      }
    },

    downloadModelloCaricato(item){
      window.open(Vue.prototype.$hostlink+"macchina/step4/modellocaricato/download/"+this.idMacchina+"/"+item.idModello)
    },
    eliminaModelloCaricato(item){
      return Vue.http.post('macchina/step4/modellocaricato/destroy/'+this.idMacchina+'/'+item.idModello, {}, {credentials : true}).then(response => {
        if(response.body.success){
          this.listModelloSelected()
          
          Vue.notify({
              group: 'global',
              title: 'Operazione eseguita',
              text: "Documento eliminato con successo!",
              type: 'success'
          })
        }else{
          Vue.notify({
              group: 'global',
              title: 'Errore',
              text: response.body.msg,
              type: 'error'
          })
        }
      }, response => {
        Vue.notify({
            group: 'global',
            title: 'Errore',
            text: "Errore eliminazione documento!",
            type: 'error'
        })
      })
    },

    loadMap(){
      map = new google.maps.Map(document.getElementById('ubicazione_map'), {
        center: {lat: 42.504154, lng: 12.646361},
        streetViewControl: false,
        zoom: 6
      })

      var input = document.getElementById('search_box')
      var searchBox = new google.maps.places.SearchBox(input)
      map.controls[google.maps.ControlPosition.TOP_LEFT].push(input)

      var localthis = this

      map.addListener('bounds_changed', function() {
        searchBox.setBounds(map.getBounds())
      })

      markers = []

      searchBox.addListener('places_changed', function() {
        var places = searchBox.getPlaces()

        localthis.setMap(places)
      })
    },
    setMap(places){
      this.state.search_address = null
      var check_msg = this.checkAddress(places)
      if(check_msg.length > 0){
        Vue.notify({
          group: 'global',
          title: 'Ubicazione errata!',
          text: check_msg[1],
          type: check_msg[0]
        })

        if(check_msg[0] == "error")
          this.state.search_address = false

        places = []
      }else{
        this.setByPlace(places[0].formatted_address)
      }

      markers.forEach(function(marker) {
        marker.setMap(null)
      })
      markers = []

      var bounds = new google.maps.LatLngBounds()
      places.forEach(function(place) {
        if (!place.geometry) {
          console.log("Returned place contains no geometry")
          return
        }
        var icon = {
          url: place.icon,
          size: new google.maps.Size(71, 71),
          origin: new google.maps.Point(0, 0),
          anchor: new google.maps.Point(17, 34),
          scaledSize: new google.maps.Size(25, 25)
        }

        markers.push(new google.maps.Marker({
          map: map,
          icon: icon,
          title: place.name,
          position: place.geometry.location
        }))

        if (place.geometry.viewport) {
          bounds.union(place.geometry.viewport)
        } else {
          bounds.extend(place.geometry.location)
        }
      })
      map.fitBounds(bounds)
    },
    checkAddress(places){
      if(!places || places.length == 0 || places.length > 1){
        return ['info', "Non è stato possibile trovare il punto esatto dell'indirizzo fornito!"]
      }

      var luogo = places[0].formatted_address

      document.getElementById('search_box').value = luogo
      
      var campi = luogo.split(",")

      if(campi.length != 4){
        return ["error", "L'indirizzo inserito non è completo di tutte le informazioni necessarie!"]
      }

      if(campi[1].trim().split(" ").length != 1){
        return ["error", "Assicurati di aver selezionato correttamente la tua ubicazione e di aver selezionato un punto bel preciso!"]
      }

      if(!(campi[3].trim() == "Italia" || campi[3].trim() == "Italy")){
        return ["error", "Attualmente sono supportati solo indirizzi italiani! Per qualsiasi dubbio contattare l'assistenza."]
      }

      var sub_campi = campi[2].trim().split(" ")

      if(sub_campi.length < 3)
        return ["error", "L'indirizzo inserito non è valido!"]

      if(isNaN(Number.parseInt(sub_campi[0].trim())))
        return ["error", "L'indirizzo inserito non contiene un CAP valido! Riprovare."]

      if(sub_campi[sub_campi.length - 1].trim().length != 2)
        return ["error", "La provincia inserita non è valida!"]

      return []
    },
    setByPlace(places){
      console.log(places)

      document.getElementById('search_box').value = places

      var campi = places.split(",")

      this.formData.step1.via = campi[0]
      this.formData.step1.civico = campi[1]
      this.formData.step1.nazione = campi[3] //TODO: se cerco indirizzo fuori italia ho problemi nella formattazione dell'indirizzo

      var sub_campi = campi[2].split(" ")

      this.formData.step1.cap = sub_campi[1]
      this.formData.step1.provincia = sub_campi[sub_campi.length - 1]
      this.formData.step1.comune = sub_campi.slice(2, sub_campi.length - 1).join(" ")
    },
    getListOption(tipo){
      var list = []

      Vue.http.post('selectlist/'+tipo, {}, {credentials : true}).then(response => {
        if(response.body.success){
          for(var i=0; i<response.body.list.length; i++){
            if(response.body.list[i].codice)
              list.push({value: response.body.list[i].id, text: response.body.list[i].codice+" - "+response.body.list[i].nome})
            else
              list.push({value: response.body.list[i].id, text: response.body.list[i].nome})
          }
        }else{
          Vue.notify({
              group: 'global',
              title: 'Errore',
              text: "Lista "+tipo+" non caricata correttamente.",
              type: 'error'
          })
        }
      }, response => {
        Vue.notify({
            group: 'global',
            title: 'Errore',
            text: "Lista "+tipo+" non caricata correttamente.",
            type: 'error'
        })
      })

      return list
    },
    openModalIndirizzo(){
      Vue.http.post('selectlist/indirizzi_cliente/'+this.formData.step1.idCliente, {}, {credentials : true}).then(response => {
        if(response.body.success){
          this.option.cliente_indirizzi = response.body.list.map(e => {
            if(e.nazione.slice(0, 2) == "M_")
              e.nazione = e.nazione.slice(2)

            return e
          })
          this.totalRows = response.body.list.length

          this.modal.indirizzo = true
        }else{
          Vue.notify({
              group: 'global',
              title: 'Errore',
              text: "Lista indirizzi del cliente non caricata correttamente.",
              type: 'error'
          })
        }
      }, response => {
        Vue.notify({
            group: 'global',
            title: 'Errore',
            text: "Lista indirizzi del cliente non caricata correttamente.",
            type: 'error'
        })
      })
    },
    selectIndirizzo(item){
      this.formData.step1.idTipoluogo = item.idTipoluogo
      this.formData.step1.nazione = item.nazione
      this.formData.step1.provincia = item.provincia
      this.formData.step1.comune = item.comune
      this.formData.step1.via = item.via
      this.formData.step1.civico = item.civico
      this.formData.step1.cap = item.cap

      this.formData.step1.princ_nome = item.princ_nome
      this.formData.step1.princ_email = item.princ_email
      this.formData.step1.princ_cellulare = item.princ_cellulare
      this.formData.step1.princ_telefono = item.princ_telefono
      this.formData.step1.princ_indirizzo = item.princ_indirizzo
      this.formData.step1.referente1 = item.referente1
      this.formData.step1.email1 = item.email1
      this.formData.step1.cellulare1 = item.cellulare1
      this.formData.step1.telefono1 = item.telefono1
      this.formData.step1.referente2 = item.referente2
      this.formData.step1.email2 = item.email2
      this.formData.step1.cellulare2 = item.cellulare2
      this.formData.step1.telefono2 = item.telefono2

      document.getElementById('search_box').value = this.formData.step1.via+", "+this.formData.step1.civico+", "+this.formData.step1.cap+
                      " "+this.formData.step1.comune+" "+this.formData.step1.provincia+", "+this.formData.step1.nazione

      var localthis = this
      
      var service = new google.maps.places.PlacesService(map);
      
      var request = {
        query: document.getElementById('search_box').value,
        fields: ['formatted_address', 'geometry', 'html_attributions', 'icon', 'id', 'name', 'place_id', 'plus_code', 'reference', 'types'],
      }

      service.findPlaceFromQuery(request, function(results, status) {
        localthis.setMap(results)
      })

      this.modal.indirizzo =  false
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },

    listModelloSelected(){
      return Vue.http.post('macchina/step4/'+this.idMacchina+'/listselected', {}, {credentials : true}).then(response => {
        if(response.body.success){
          this.formData.step4.modelli = response.body.list
          this.docmanufatto.doctecnici.totalRows = response.body.list.length
        }else{
          Vue.notify({
              group: 'global',
              title: 'Errore',
              text: response.body.msg,
              type: 'error'
          })
        }
      }, response => {
        Vue.notify({
            group: 'global',
            title: 'Errore',
            text: "Errore caricamento lista!",
            type: 'error'
        })
      })
    },
    selectModello(item){
      /*var modello = JSON.parse(JSON.stringify(item))
      modello.note = ""
      this.formData.step4.modelli.push(modello)
      this.docmanufatto.doctecnici.totalRows = this.formData.step4.modelli.length*/
      if(item.loading)
        return

      item.loading = true

      return Vue.http.post('macchina/step4/'+this.idMacchina+'/add', {idModello: item.idModello, versione: item.versione}, {credentials : true}).then(response => {
        if(response.body.success){
          this.listModelloSelected()
          item.loading = false
        }else{
          item.loading = false
          Vue.notify({
              group: 'global',
              title: 'Errore',
              text: response.body.msg,
              type: 'error'
          })
        }
      }, response => {
        Vue.notify({
            group: 'global',
            title: 'Errore',
            text: "Errore caricamento lista!",
            type: 'error'
        })
      })
    },
    removeModello(item){
      /*this.formData.step4.modelli = this.formData.step4.modelli.filter(e => {
        if(e.idModello == item.idModello)
          return false
        return true
      })
      this.docmanufatto.doctecnici.totalRows = this.formData.step4.modelli.length*/

      return Vue.http.post('macchina/step4/'+this.idMacchina+'/destroy/'+item.id, {}, {credentials : true}).then(response => {
        if(response.body.success){
          this.listModelloSelected()
          
          Vue.notify({
              group: 'global',
              title: 'Operazione eseguita',
              text: "Documento manufatto eliminato con successo!",
              type: 'success'
          })
        }else{
          Vue.notify({
              group: 'global',
              title: 'Errore',
              text: response.body.msg,
              type: 'error'
          })
        }
      }, response => {
        Vue.notify({
            group: 'global',
            title: 'Errore',
            text: "Errore caricamento lista!",
            type: 'error'
        })
      })
    },

    loadListComponente(){
      Vue.http.post('macchina/step3/'+this.idMacchina+'/list', {}, {credentials : true}).then(response => {
        if(response.body.success){
            this.formData.step3.componenti = response.body.data
            this.componenti.totalRows = this.formData.step3.componenti.length
        }
      }, response => {})
    },
    openModalComponente(){
      this.modalForm.componente = {
        codcatalogo: '',
        idMarca: null,
        quantita: null,
        numserie: '',
        idTipocomponente: null,
        idSottotipocomponente: null,
        descrizione: '',
        note: ''
      }

      this.modalForm.componente_file = {
        file1: null,
        file2: null
      }
      
      this.modal.componente = true
    },
    openModalListaComponente(){
      this.aggiungi_componenti.elemento_selezionato = {}
      this.modalForm.aggiungi_componente = {
        idComponente: null,
        quantita: null,
        numserie: ''
      }

      Vue.http.post('elenco/componenti', {}, {credentials : true}).then(response => {
        if(response.body.success){
            this.aggiungi_componenti.elenco = response.body.list
            this.aggiungi_componenti.totalRows = this.aggiungi_componenti.elenco.length

            this.buttonState.modifica_componente = false
            this.modal.aggiungi_componente = true
        }else{
          Vue.notify({
            group: 'global',
            title: 'Errore',
            text: "Non ci sono componenti in lista!",
            type: 'error'
          })
        }
      }, response => {})
    },
    onFilteredAggiungiComponente(filteredItems) {
      this.aggiungi_componenti.totalRows = filteredItems.length
      this.aggiungi_componenti.currentPage = 1
    },
    selectComponente(item){
      this.modalForm.aggiungi_componente.idComponente = item.id
      this.aggiungi_componenti.elemento_selezionato = item
    },
    addListaComponente(){
      if(this.modalForm.aggiungi_componente.id){
        var id = this.modalForm.aggiungi_componente.id
        delete this.modalForm.aggiungi_componente.id
      }

      return Vue.http.post('macchina/step3/'+this.idMacchina+'/componente/'+((this.buttonState.modifica_componente) ? 'modifica/'+id : 'aggiungi'), {step3: this.modalForm.aggiungi_componente}, {credentials : true}).then(response => {
        if(response.body.success){
          this.loadListComponente()
          
          this.buttonState.modifica_componente = false
          this.modal.aggiungi_componente = false

          return true
        }else{
          for(var i=0; i<Object.keys(this.state).length; i++){
            this.state[Object.keys(this.state)[i]] = null
          }

          for(var i=0; i<response.body.inputError.length; i++){
            this.state[response.body.inputError[i]] = false
          }
          
          Vue.notify({
              group: 'global',
              title: 'Errore',
              text: response.body.msg,
              type: 'error'
          })
          return false
        }
      }, response => {
        Vue.notify({
            group: 'global',
            title: 'Errore',
            text: "Errore durante l'aggiunta del componente!",
            type: 'error'
        })
        
        return false
      })
    },
    addComponente(){
      if(this.buttonState.componenti)
        return
      
      this.buttonState.componenti = true

      var formSend = new FormData()
      formSend.append("step3", JSON.stringify(this.modalForm.componente))

      var i=0
      if(this.modalForm.componente_file.file1)
        formSend.append('documenti', this.modalForm.componente_file.file1, this.modalForm.componente_file.file1.name)
      
      if(this.modalForm.componente_file.file2)
        formSend.append('documenti', this.modalForm.componente_file.file2, this.modalForm.componente_file.file2.name)

      return Vue.http.post('macchina/step3/'+this.idMacchina+'/componente', formSend, {credentials : true}).then(response => {
        if(response.body.success){
          this.loadListComponente()
          
          this.modal.componente = false
          this.buttonState.componenti = false

          return true
        }else{
          this.buttonState.componenti = false
          /*for(var i=0; i<Object.keys(this.state).length; i++){
            this.state[Object.keys(this.state)[i]] = null
          }

          for(var i=0; i<response.body.inputError.length; i++){
            this.state[response.body.inputError[i]] = false
          }*/ //TODO: mettere check per componente
          
          Vue.notify({
              group: 'global',
              title: 'Errore',
              text: response.body.msg,
              type: 'error'
          })
          return false
        }
      }, response => {
        Vue.notify({
            group: 'global',
            title: 'Errore',
            text: "Errore durante l'esecuzione dello step 1!",
            type: 'error'
        })
        
        return false
      })
    },
    
    openModalDeleteComponente(item){
      this.modalForm.delete = item
      this.modal.delete = true
    },
    openModalEditComponente(item){
      this.aggiungi_componenti.elemento_selezionato = {}
      this.modalForm.aggiungi_componente = {
        idComponente: item.idComponente,
        quantita: item.quantita,
        numserie: item.numserie,
        id: item.id
      }

      Vue.http.post('elenco/componenti', {}, {credentials : true}).then(response => {
        if(response.body.success){
            this.aggiungi_componenti.elenco = response.body.list
            this.aggiungi_componenti.totalRows = this.aggiungi_componenti.elenco.length

            this.aggiungi_componenti.elemento_selezionato = this.aggiungi_componenti.elenco.find(e => {
              return e.id == item.idComponente
            })

            this.buttonState.modifica_componente = true
            this.modal.aggiungi_componente = true
        }else{
          Vue.notify({
            group: 'global',
            title: 'Errore',
            text: "Non ci sono componenti in lista!",
            type: 'error'
          })
        }
      }, response => {})
    },
    deleteComponente(id){
      Vue.http.post('macchina/step3/'+this.idMacchina+"/delete/"+id, {}, {credentials : true}).then(response => {
        if(response.body.success){
          this.loadListComponente()

          this.modalForm.delete = {}
          this.modal.delete = false

          Vue.notify({
              group: 'global',
              title: 'Operazione eseguita',
              text: 'Componente eliminato con successo!',
              type: 'success'
          })
        }else{        
          Vue.notify({
              group: 'global',
              title: 'Errore',
              text: response.body.msg,
              type: 'error'
          })
        }
      }, response => {
        Vue.notify({
            group: 'global',
            title: 'Errore',
            text: "Errore!",
            type: 'error'
        })
      })
    },

    loadListDocumenti(){
      Vue.http.post('macchina/step5/'+this.idMacchina+'/list', {}, {credentials : true}).then(response => {
        if(response.body.success){
            this.formData.step5.documenti = response.body.data
            this.documenti.totalRows = this.formData.step5.documenti.length
        }
      }, response => {})
    },
    addDocumento(){
      if(this.buttonState.documento_generale)
        return
      
      if(this.$refs.pond.getFiles().length > 0){
        this.buttonState.documento_generale = true
        var formSend = new FormData()
        formSend.append('documento', this.$refs.pond.getFiles()[0].file, this.$refs.pond.getFiles()[0].file.name)
        
        console.log(this.$refs.pond.getFiles()[0].file)
        Vue.http.post('macchina/step5/'+this.idMacchina+'/upload', formSend, {credentials : true}).then(response => {
          if(response.body.success){
            this.buttonState.documento_generale = false

            this.documenti.file = []
            this.loadListDocumenti()
          }else{
            this.buttonState.documento_generale = false
            Vue.notify({
                group: 'global',
                title: 'Errore',
                text: response.body.msg,
                type: 'error'
            })
          }
        }, response => {
          Vue.notify({
              group: 'global',
              title: 'Errore',
              text: "Errore!",
              type: 'error'
          })
        })
      }
    },
    openModalDeleteDocumento(item){
      this.modalForm.delete_doc = item
      this.modal.delete_doc = true
    },
    deleteDocumento(id){
      Vue.http.post('macchina/step5/'+this.idMacchina+"/delete/"+id, {}, {credentials : true}).then(response => {
        if(response.body.success){
          this.loadListDocumenti()

          this.modalForm.delete_doc = {}
          this.modal.delete_doc = false

          Vue.notify({
              group: 'global',
              title: 'Operazione eseguita',
              text: 'Documento eliminato con successo!',
              type: 'success'
          })
        }else{        
          Vue.notify({
              group: 'global',
              title: 'Errore',
              text: response.body.msg,
              type: 'error'
          })
        }
      }, response => {
        Vue.notify({
            group: 'global',
            title: 'Errore',
            text: "Errore!",
            type: 'error'
        })
      })
    },

    loadRiepilogo(){
      Vue.http.post('macchina/step6/'+this.idMacchina+'/list', {}, {credentials : true}).then(response => {
        if(response.body.success){
            this.formData.step6.riepilogo = response.body.data

            this.riepilogo.docgenerali.totalRows = this.formData.step6.riepilogo.docgenerali.length
            this.riepilogo.doccomponente.totalRows = this.formData.step6.riepilogo.doccomponente.length
            this.riepilogo.docmanufatto.totalRows = this.formData.step6.riepilogo.docmanufatto.length
              
        }
      }, response => {})
    },
    selezionaTutto(){
      this.formData.step6.riepilogo.docgenerali.forEach(e => {
        e.stampa = true
      })

      this.formData.step6.riepilogo.doccomponente.forEach(e => {
        e.stampa = true
      })

      this.formData.step6.riepilogo.docmanufatto.forEach(e => {
        e.stampa = true
      })
    },
    deselezionaTutto(){
      this.formData.step6.riepilogo.docgenerali.forEach(e => {
        e.stampa = false
      })

      this.formData.step6.riepilogo.doccomponente.forEach(e => {
        e.stampa = false
      })

      this.formData.step6.riepilogo.docmanufatto.forEach(e => {
        e.stampa = false
      })
    },
    generaPacchetto(){
      var req = JSON.parse(JSON.stringify(this.formData.step6))
      this.buttonState.genera = true
      req.riepilogo.docmanufatto = req.riepilogo.docmanufatto.filter(e => e.stampa).map(e => e.id)
      req.riepilogo.docgenerali = req.riepilogo.docgenerali.filter(e => e.stampa).map(e => e.id)
      req.riepilogo.doccomponente = req.riepilogo.doccomponente.filter(e => e.stampa).map(e => e.id)

      return Vue.http.post('macchina/step6/'+this.idMacchina+'/genera', {step6: req}, {credentials : true}).then(response => {
        if(response.body.success){
          this.$router.push({name: 'macchinepacchetti', params: {id: this.idMacchina}})

          Vue.notify({
              group: 'global',
              title: 'Operazione eseguita',
              text: 'Generazione pacchetto in corso!',
              type: 'success'
          })
        }else{
          Vue.notify({
              group: 'global',
              title: 'Errore',
              text: response.body.msg,
              type: 'error'
          })
        }

        this.buttonState.genera = false
      }, response => {
        Vue.notify({
            group: 'global',
            title: 'Errore',
            text: "Errore durante l'esecuzione dello step 1!",
            type: 'error'
        })
        this.buttonState.genera = false
      })
    }
  }
}
</script>

<style scoped>
/* MACCHINA */
#search_box{
  width: 60%;
  margin-top: 10px;
  margin-left: 20px;
}

#ubicazione_map{
  width: 100%;
  height: 400px;
  border-radius: 4px;

  -webkit-box-shadow: 0px 0px 15px 0px rgba(0,0,0,0.5);
  -moz-box-shadow: 0px 0px 15px 0px rgba(0,0,0,0.5);
  box-shadow: 0px 0px 15px 0px rgba(0,0,0,0.5);
}

#referente{
  text-indent: 100px;
}

#email{
  text-indent: 70px;
}

#cellulare{
  text-indent: 95px;
}

#telefono{
  text-indent: 130px;
}

#codprodotto{
  text-indent: 105px;
}

#idCliente{
  text-indent: 90px;
}

#via{
  text-indent: 60px;
}

#civico{
  text-indent: 80px;
}

#nazione{
  text-indent: 95px;
}

#provincia{
  text-indent: 105px;
}

#comune{
  text-indent: 100px;
}

#cap{
  text-indent: 70px;
}

#idTipoluogo{
  text-indent: 155px;
}

#descrizione{
  text-indent: 125px;
  line-height: 1.8;
}

#datainstallazione{
  text-indent: 140px;
}

#datacollaudo{
  text-indent: 115px;
}

#iniziogaranzia{
  text-indent: 95px;
}

#finegaranzia{
  text-indent: 90px;
}

#estensionegaranzia{
  text-indent: 160px;
}

#note{
  text-indent: 65px;
  line-height: 1.8;
}

#docprestazione{
  text-indent: 215px;
  line-height: 1.8;
}

#passcentrale{
  text-indent: 275px;
}

#freqmanutenzione{
  text-indent: 270px;
}

#descimpianto{
  text-indent: 180px;
  line-height: 1.8;
}

#proprietario{
  text-indent: 270px;
}

#idTipomacchina{
  text-indent: 180px;
}

#idTipoelettrico{
  text-indent: 180px;
}

#indirizzo{
  text-indent: 90px;
}

/* MANUFATTO */

#idTipomanufatto{
  text-indent: 185px;
}

#idTipoutilizzo{
  text-indent: 165px;
}

#idTipouso{
  text-indent: 200px;
}

#idTipotamponamento{
  text-indent: 225px;
}

#datainstallazione-2{
  text-indent: 120px;
}

#datapresaincarico{
  text-indent: 135px;
}

#matrmanufatto{
  text-indent: 200px;
}

#classevetro{
  text-indent: 205px;
}

#dimluce{
  text-indent: 235px;
}

#peso{
  text-indent: 70px;
}

#altezza{
  text-indent: 85px;
}

#numante{
  text-indent: 125px;
}

#lunganta{
  text-indent: 145px;
}

#docmanufatto{
  text-indent: 280px;
  line-height: 1.8;
}

#idCostruttore{
  text-indent: 120px;
}

/* DOCUMENTI MANUFATTO */


/* COMPONENTI */
#codcatalogo{
  text-indent: 160px;
}

#idMarca{
  text-indent: 85px;
}

#quantita{
  text-indent: 100px;
}

#numserie{
  text-indent: 125px;
}

#idTipocomponente{
  text-indent: 220px;
}

#idSottotipocomponente{
  text-indent: 255px;
}

#descrizione{
  text-indent: 120px;
  line-height: 1.8;
}

#note{
  text-indent: 70px;
  line-height: 1.8;
}

/* RIEPILOGO */
#nomefile{
  text-indent: 160px;
}
</style>

<style>
.table_size_col1{
  min-width: 130px;
  max-width: 130px;
}

.table_size_col2{
  min-width: 130px;
  max-width: 130px;
}

.table_size_col3{
  min-width: 70px;
  max-width: 70px;
}

.table_size_col4{
  min-width: 20px;
  max-width: 20px;
}

.table_size_col5{
  min-width: 40px;
  max-width: 40px;
}

.col_text_cut{
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

#box_info_componente{
  background: #493240;
    color: white;
    padding: 10px;
    margin: 10px;
    margin-top: 20px;
    border-radius: 6px;
}
</style>